import {
  IvsApiConstants,
  type ApolloClientOptionalOptions,
} from '@trp-dms-digital-shared/ds-ui-library-api';

// actual API key - we need a .env solution
const APIKEY_DEV = 's2vGTJNuKLNsrWH5FZd1qGeJhAhkbAUO';
const APIKEY_STAGE = 'YDqGubcs4EMrQmKcPzk1azxLwCaD1d4F';
const APIKEY_PROD = 'lhiKZfzAAJX3bpABwQknSzBXSKic6OaC';

const ENDPOINT_DEV = IvsApiConstants.ENDPOINT_DEV.toString();
const ENDPOINT_STAGE = IvsApiConstants.ENDPOINT_STAGE.toString();
const ENDPOINT_PROD = IvsApiConstants.ENDPOINT_PROD.toString();

// unique default setup for ivs-api-base
const CLIENT_DEFAULT_OPTS: ApolloClientOptionalOptions = {
  ssrMode: true,
  ...IvsApiConstants.CLIENT_DEFAULT_OPTS,
  headers: {
    ...IvsApiConstants.CLIENT_DEFAULT_OPTS.headers,
    apikey: APIKEY_PROD,
  },
  uri: ENDPOINT_PROD,
};

export const Constants = {
  TAG_NAME: 'pop-ivs-api-base-component',
  DATA_FRAGMENT: 'data-fragment',
  DATA_TICKER: 'data-ticker',
  DATA_ENVIRONMENT: 'data-environment',
  DATA_QUERY_TYPE: 'data-query-type',
  POPCONFIG_ENDPOINT: 'ivs-endpoint',
  POPCONFIG_APIKEY: 'ivs-apikey',
  CLIENT_DEFAULT_OPTS,
  ENDPOINT_DEV,
  ENDPOINT_STAGE,
  ENDPOINT_PROD,
  APIKEY_DEV,
  APIKEY_STAGE,
  APIKEY_PROD,
  QUERY_TYPES: IvsApiConstants.QUERY_TYPES,
  LOG_PREFIX: 'IVS-API-BASE: ',
} as const;
